import React, { useEffect, useState } from 'react'
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

const SchoolLeavingCertificate = () => {

  const [studied,setStudied]=useState("");
  const [studiedAlphabet,setStudiedAlphabet]=useState("");

  const [admissionNo,setAdmissionNo]=useState("");
  const [pupilFirstName, setPupilFirstName] = useState("");
  const [pupilMiddleName, setPupilMiddleName] = useState("");
  const [pupilLastName, setPupilLastName] = useState("");
  const [gaurdianFirstName, setGaurdianFirstName] = useState("");
  const [gaurdianMiddleName, setGaurdianMiddleName] = useState("");
  const [gaurdianLastName, setGaurdianLastName] = useState("");
  const [nationality,setNationality] = useState("");
  const [candidateBelongs,setCandidateBelongs] = useState("");
  const [firstAdmissionDate,setFirstAdmissionDate] = useState("");
  const [dateOfBirth,setDateOfBirth] = useState("");
  const [dateOfBirthWord,setDateOfBirthWord] = useState("");
  const [schoolBoard,setSchoolBoard] = useState("");
  const [failed,setFailed] = useState("");
  const [subjectStudid,setSubjectStudid] = useState("");
  const [higherClass,setHigherClass] = useState("");
  const [whichClass,setWhichClass] = useState("");
  const [schoolDues,setSchoolDues] = useState("");
  const [feeConcession,setFeeConcession] = useState("");
  const [workingDays,setWorkingDays] = useState("");
  const [presentWorkingDays,setPresentWorkingDays] = useState("");
  const [nccCadet,setNccCadet] = useState("");
  const [gamesPlayed,setGamesPlayed] = useState("");
  const [generalConduct,setGeneralConduct] = useState("");
  const [dateApplicationCertificate,setDateApplicationCertificate] = useState("");
  const [dateIssueCertificate,setDateIssueCertificate] = useState("");
  const [reasonLeaving,setReasonLeaving] = useState("");
  const [remarks,setRemarks] = useState("");

  const Class =[
    {num:1,val:"one"},
    {num:2,val:"Two"},
    {num:3,val:"Three"},
    {num:4,val:"Four"},
    {num:5,val:"Five"},
    {num:6,val:"Six"},
    {num:7,val:"Seven"},
    {num:8,val:"Eight"},
    {num:9,val:"Nine"},
    {num:10,val:"Ten"},
    {num:11,val:"Eleven"},
    {num:12,val:"Twelve"}, 
  ]

 useEffect(()=>{
 if(studied.length>0 && studied!=="null"){ const temp=Class.find((elem)=>elem.num===parseInt(studied)).val
  setStudiedAlphabet(temp);}
  else if(studied==="null"){ setStudiedAlphabet("Please Select Standard")}
 },[studied])



 const  transferCertificate = async () => {
  await addDoc(collection(db, "leavingCertificate"), {
    admissionNo,
    pupilFirstName,
    pupilMiddleName,
    pupilLastName,
    gaurdianFirstName,
    gaurdianMiddleName,
    gaurdianLastName,
    nationality,
    candidateBelongs,
    firstAdmissionDate,
    dateOfBirth,
    dateOfBirthWord,
    pupilLastStudid:studied,
    pupilLastStudidAlphabet:studiedAlphabet,
    schoolBoard,
    failed,
    subjectStudid,
    higherClass,
    whichClass,
    schoolDues,
    feeConcession,
    workingDays,
    presentWorkingDays,
    nccCadet,
    gamesPlayed,
    generalConduct,
    dateApplicationCertificate,
    dateIssueCertificate,
    reasonLeaving,
    remarks
  });
};


  return (
    <div className="w-full p-5 text-gray-700">
        <div className="grid grid-cols-7 gap-4">
        <div className='justify-items-center items-center' >
         <img src="../assets/sail.png" alt="pic" className='h-32 w-32' />
        </div>
        <div className="mb-2 text-center w-full col-span-5">
        <div className='mb-1 '> 
                <span className="font-bold  text-3xl ">
                    BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
                </span>
        </div>
        <div className='grid grid-cols-9 gap-4'>
        <div className='mb-1 col-span-5 ml-10'> 
        <span className="text-xl ">
                    BOKARO STEEL CITY, JHARKHAND
                 </span>
        </div>
        <div className='mb-1 col-span-3'> 
        <span className="text-xl ">
                 CBSE Affiliation No.
                 </span>
        </div>
        </div>  
      <div className='mb-1 mt-5'> 
      <span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
         SCHOOL LEAVING CERTIFICATE
        </span>
      </div>

        </div>
        <div className='justify-items-center items-center' >
         <img src="../assets/as_logo.png" alt="pic" className='h-32 w-32' />
        </div>
        </div>
     <div className="w-full mt-5">
    <div className="grid grid-cols-4 gap-4">
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/3">
            <label
              className="block font-bold md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              Book No.
            </label>
          </div>
          <div className="md:w-2/3">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/4">
            <label
              className="block font-bold md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              Sl No.
            </label>
          </div>
          <div className="md:w-4/5">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>

        <div className="md:flex md:items-center mb-6 col-span-2">
          <div className="md:w-1/3">
            <label
              className="block font-bold md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              Admission No.
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"
              placeholder='Admission No.'
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={admissionNo}
              onChange={(e) => {
                setAdmissionNo(e.target.value);
              }}
            />
          </div>
        </div>
      </div>

      <div className=" w-full md:flex  md:items-center mb-6 ">
        <div className="mb-4 md:w-1/5">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
              Name of Pupil
          </label>
        </div>
        <div className="grid grid-cols-3 gap-4 md:w-5/6">
        <div className="md:flex md:items-center ">
          <div className="md:w-5/6">
            <input
              type="text" 
              placeholder='First Name'          
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={pupilFirstName}
              onChange={(e) => {
                setPupilFirstName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="md:flex md:items-center ">
          <div className="md:w-5/6">
            <input
              type="text" 
              placeholder='Middle Name'           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={pupilMiddleName}
              onChange={(e) => {
                setPupilMiddleName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="md:flex md:items-center ">
          <div className="md:w-5/6">
            <input
              type="text"   
              placeholder='Last Name'         
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={pupilLastName}
              onChange={(e) => {
                setPupilLastName(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      </div>
      <div className=" w-full md:flex  md:items-center mb-6 ">
        <div className="mb-4 md:w-1/5">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Father's/Gaurdian's Name
          </label>
        </div>
        <div className="grid grid-cols-3 gap-4 md:w-5/6">
        <div className="md:flex md:items-center ">
          <div className="md:w-5/6">
            <input
              type="text" 
              placeholder='First Name'           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={gaurdianFirstName}
              onChange={(e) => {
                setGaurdianFirstName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="md:flex md:items-center ">
          <div className="md:w-5/6">
            <input
              type="text" 
              placeholder='Middle Name'           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={gaurdianMiddleName}
              onChange={(e) => {
                setGaurdianMiddleName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="md:flex md:items-center ">
          <div className="md:w-5/6">
            <input
              type="text" 
              placeholder='Last Name'         
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={gaurdianLastName}
              onChange={(e) => {
                setGaurdianLastName(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      </div>
      <div className=" w-full md:flex  md:items-center mb-6 ">
        <div className="mb-4 md:w-1/5">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Nationality
          </label>
        </div>
        <div className="md:w-1/2">
        <select className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                      value={nationality}
                      onChange={(e) => {
                        setNationality(e.target.value);
                      }}
                    >
                       <option value="select"> select</option>
                      <option value="Indian">Indian</option>
                      <option value="Other">Other</option>
                    </select>
        </div>
      </div>

      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Whether the candidate belongs to Schedule Caste or Schedule Tribe 
          </label>
        </div>
        <div className="md:w-1/2">
        <select className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                      value={candidateBelongs}
                      onChange={(e) => {
                        setCandidateBelongs(e.target.value);
                      }}
                    >
                       <option value="select"> select</option>
                      <option value="Schedule Caste">Schedule Caste</option>
                      <option value="Schedule Tribe">Schedule Tribe</option>
                      <option value="General">General</option>
                      <option value="OBC I">OBC I</option>
                      <option value="OBC II">OBC II</option>
                    </select>
        </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Date of first admission in the School with class
          </label>
        </div>
        <div className="md:w-2/3">
          <input
            type="date"
            className=" w-96 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            placeholder="Select a date" 
            value={firstAdmissionDate}
            onChange={(e) => {
              setFirstAdmissionDate(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="pt-1 ">
            <label
              className="block  md:text-left mb-1  "
              htmlFor="inline-full-name"
            >
              Date of Birth (in Christian Era) according to Admission Register
            </label>
          
      <div className="grid grid-cols-2 gap-4">
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              (in figures)
            </label>
          </div>
          <div className="md:w-5/6">
          <input
            type="date"
            className=" w-96 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            placeholder="Select a date"
            value={dateOfBirth}
            onChange={(e) => {
              setDateOfBirth(e.target.value);
            }} 
          />
        </div>
        </div>

        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              (in words)
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={dateOfBirthWord}
            onChange={(e) => {
              setDateOfBirthWord(e.target.value);
            }}
            />
          </div>
        </div>
      </div>
    </div> 
    <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/3">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Class in which the pupil last studied
          </label>
        </div>
        
        <div className="grid grid-cols-2 gap-4 md:w-2/3">
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/2">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              (in figures)
            </label>
          </div>
          <div className="md:w-5/6">
            <select
              onChange={(e)=>setStudied(e.target.value)}
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            ><option value="null">Please Select Standard</option>
              {Class.map((item,index)=>
              (<option value={item.num} key={index}>{item.num}</option>)
              )
              }
              </select>
          </div>
        </div>

        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              (in words)
            </label>
          </div>
          <div className="md:w-5/6">
            <div
          
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            >{studiedAlphabet}</div>
          </div>
        </div>
      </div>
        </div>

        <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            School/Board Annual examination last taken with result
          </label>
        </div>
        <div className="md:w-2/3">
          <input
            type="text"
            className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            value={schoolBoard}
            onChange={(e) => {
              setSchoolBoard(e.target.value);
            }}
          />
        </div>
      </div>

      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Whether failed, if so once/twice in the same class
          </label>
        </div>
        <div className="md:w-2/3">
        <select 
          value={failed}
          onChange={(e) => {
            setFailed(e.target.value);
          }}
        className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
        </div>
      </div>

      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/6">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Subject Studied
          </label>
        </div>
        
        <div className="grid grid-cols-6 gap-4 md:w-5/6">
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              1
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>

        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
             2
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              3
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              4
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              5
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              6
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
      </div>
        </div>


        <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Whether Qualified for promotion to higher class
          </label>
        </div>
        <div className="md:w-2/3">
          <input
              value={higherClass}
              onChange={(e) => {
              setHigherClass(e.target.value);
                 }}
            type="text"
            className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
          />
        </div>
      </div>

      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/6">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            If so, to which class
          </label>
        </div>
        
        <div className="grid grid-cols-2 gap-4 md:w-5/6">
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/5">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              (in figures)
            </label>
          </div>
          <div className="md:w-4/5">
            <input
              type="text"           
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>

        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/6">
            <label
              className="block  md:text-left mb-1 md:mb-0 "
              htmlFor="inline-full-name"
            >
              (in words)
            </label>
          </div>
          <div className="md:w-5/6">
            <input
              type="text"
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
      </div>
        </div>

        <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Month upto which the (pupil has paid) school dues paid
          </label>
        </div>
        <div className="md:w-2/3">
          <input
                value={schoolDues}
                onChange={(e) => {
                  setSchoolDues(e.target.value);
                }}
            type="text"
            className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
          />
        </div>
      </div>

      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Any fee concession availed of : if so, the nature of such concession
          </label>
        </div>
        <div className="md:w-3/5">
        <select 
          value={feeConcession}
          onChange={(e) => {
            setFeeConcession(e.target.value);
          }}
        className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
        </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/5">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Total no. working days
          </label>
        </div>
        <div className="md:w-4/5">
          <input
            value={workingDays}
            onChange={(e) => {
              setWorkingDays(e.target.value);
            }}
            type="text"
            className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
          />
        </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/2">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Whether NCC Cadet/Boy Scout/Girl Guide (details may be given)
          </label>
        </div>
        <div className="md:w-2/3">
        <select 
          value={nccCadet}
          onChange={(e) => {
            setNccCadet(e.target.value);
          }}
        className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
        </div>
      </div>

      <div className="w-full md:flex  md:items-center">
      <div className="mb-4 md:w-5/6">
            <label
              className="block  md:text-left mb-1  "
              htmlFor="inline-full-name"
            >
            Games played or extra curricular activities in which the pupil usually took part (mention achievement level therein)
            </label>
            </div>
        <div className="md:flex md:items-center mb-6 md:w-1/5">
        <select 
             value={gamesPlayed}
             onChange={(e) => {
               setGamesPlayed(e.target.value);
             }}
        className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
          </div>
     
    </div> 
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/4">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            General conduct
          </label>
        </div>
        <div className="md:w-1/2">
           <select 
             value={generalConduct}
             onChange={(e) => {
               setGeneralConduct(e.target.value);
             }}
           className="form-select  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Good">Good</option>
                      <option value="Excellent">Excellent</option>
                      <option value="Poor">Poor</option>
                    </select>
                  </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/4">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Date of application for certificate
          </label>
        </div>
        <div className="md:w-1/2">
          <input
            value={dateApplicationCertificate}
            onChange={(e) => {
              setDateApplicationCertificate(e.target.value);
            }}
            type="date"
            className=" w-96 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            placeholder="Select a date" 
          />
        </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/4">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Date of issue for certificate
          </label>
        </div>
        <div className="md:w-1/2">
          <input
            value={dateIssueCertificate}
            onChange={(e) => {
              setDateIssueCertificate(e.target.value);
            }}
            type="date"
            className=" w-96 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            placeholder="Select a date" 
          />
        </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/5">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Reason for leaving the school
          </label>
        </div>
        <div className="md:w-4/5">
          <input
            value={reasonLeaving}
            onChange={(e) => {
              setReasonLeaving(e.target.value);
            }}
            type="text"
            className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
          />
        </div>
      </div>
      <div className=" w-full md:flex  md:items-center ">
        <div className="mb-4 md:w-1/5">
          <label
            className="block  md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Any other remarks
          </label>
        </div>
        <div className="md:w-4/5">
          <input
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
            type="text"
            className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
          />
        </div>
      </div>

      <div className='grid grid-cols-4 gap-4 mt-10'>
        <div className='font-bold '>
            <span>Signature of
            <br/> Asstt.</span>
        </div>
        <div className='font-bold '>
        <span>Signature of
        <br/> Class teacher</span>
        </div>
        <div className='font-bold '>
        <span>Checked by 
            <br/>
            (State full name and designation)
            </span>
        </div>
        <div className='font-bold '>
            <span>Principal
                <br/>
                 SEAL</span>
        </div>
      </div>
      </div>
      <div className="mt-4 ">
        <button
          className="w-24 h-10 bg-blue-400  text-2xl text-white font-semibold"
          onClick={transferCertificate}
        >
          Submit
        </button>
      </div>
   </div>
    )
}

export default SchoolLeavingCertificate